
import { Component } from '@angular/core'; 

import { FileUploader } from 'ng2-file-upload';
 
import { CommonService } from '../_Services/common.service';
import { DebtService } from '../_Services/debt.service';
import { Router, ActivatedRoute } from '@angular/router';  
import { Globals } from '../_Globals/globals'; 
const URL = 'http://192.168.4.200:8080/dmcs/backend/debt_importeds/add';
//const URL = 'http://localhost/col/backend/debt_importeds/add';

@Component({
	selector: 'simple-demo',
    templateUrl: 'uploadcollection.component.html'
})
export class UploadcollectionComponent { 
 	
 	error = '';

 	msg = '';

	constructor(private router: Router, private route:ActivatedRoute, private commonService: CommonService, private debtService: DebtService, private globals: Globals) {
		this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
			 var responsePath = JSON.parse(response);
			/*console.log(responsePath);
			this.error = '';
			if(responsePath.status === false) {
				this.error = responsePath.message;
			} else {
				this.msg = 'Assigning debt. Please wait...';
				this.debtService.assignDebt(responsePath.debt_imported_id).subscribe(result => {
		            if (result.status === true) {
		            	this.msg = 'Saving vehicles. Please wait...';
		            	this.debtService.addVehicle(responsePath.debt_imported_id).subscribe(result => {
				            if (result.status === true) {
				            	this.msg = 'Process completed. You will be redirect...';
				                this.router.navigate(['/debts/receivable']); 
				            } else {
				                this.error = 'System failed to assign debt data'; 
				            }
				        }); 
	 
		            } else {
		                this.error = 'System failed to assign debt data'; 
		            }
		        }); 	
			}
			*/
			this.router.navigate(['/debts/collected/', responsePath.collection_id]); 
		};
	}

	originating = '';

	ofs = []; 
  	onChange(value) {
	    this.originating = value;
	    console.log(value);
  	}

	public uploader:FileUploader = new FileUploader(
		{
			url: this.globals.api_url + 'collections/add',
			method: "POST",
			itemAlias: 'data[Collection][file]'
		}
	);
	 
	ngAfterViewInit() {
		this.uploader.onAfterAddingFile = (item => {
			item.withCredentials = false;
			if(this.originating == '') {
				alert('Please select Payment Channel');
			}
		});
	} 

	ngOnInit() {
		// Upload form
		this.uploader.onBuildItemForm = (item, form) => {
			form.append("data[Collection][name]", this.originating);
			form.append("data[Collection][dir]", '');
			form.append("data[Collection][finance_service_id]", this.originating);
		};

		// common ofs
		this.commonService.getOfs().subscribe(result => {
                console.log(result);
                this.ofs = result;
            }); 
	}
}


// WEBPACK FOOTER //
// ./src/app/debts/uploadcollection.component.ts